import React from "react";
import { techStackDetails } from "../Details";

function Technologies() {
  const {
    html,
    css,
    js,
    react,
    vue,
    python,
    bootstrap,
    sass,
    vscode,
    git,
    github,
    wordpress,
    postman,
    figma,
    tableau,
    powerbi,
    excel,
    word,
    powerpoint,
    plotly,
    seaborn,
    matplotlib,
    typescript,
  } = techStackDetails;
  return (
    <main className="container mx-auto max-width pt-10 pb-20 ">
      <section>
        <h1 className="text-2xl text-gradient text-dark-heading  md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Tech Stack
        </h1>
        <p className="text-content py-2 lg:max-w-3xl">
          Technologies I've been working with recently
        </p>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
      <img src={python} title="Python" alt="" />
        <img src={js} title="JavaScript" alt="" />
        <img src={react} title="React" alt="" />
        <img src={vue} title="Vue.js" alt="" />
        <img src={typescript} title="Vue.js" alt="" />
        <img src={html} title="html" alt="" />
        <img src={css} title="CSS" alt="" />
      </section>

      <section>
        <h1 className="text-2xl pt-10 text-gradient text-dark-heading  md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Data Visualization Tools & Libraries
        </h1>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={tableau} title="Tableau" alt="Tableau" />
        <img src={powerbi} title="Power Bi" alt="Power Bi" />
        <img src={plotly} title="Plotly" alt="Plotly" />
        <img src={seaborn} title="Seaborn" alt="Seaborn" />
        <img src={matplotlib} title="Matplotlib" alt="Matplotlib" />
      </section>

      <section>
        <h1 className="text-2xl pt-10 text-gradient text-dark-heading  md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Microsoft Office Tools
        </h1>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={excel} title="Excel" alt="Excel" />
        <img src={word} title="Word" alt="Word" />
        <img src={powerpoint} title="PowerPoint" alt="PowerPoint" />
      </section>


      <section>
        <h1 className="text-2xl pt-10 text-gradient text-dark-heading  md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Other Tools & Frameworks
        </h1>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={bootstrap} title="Bootstrap" alt="Bootstrap" />
        <img src={sass} title="SASS" alt="SASS" />
        <img src={vscode} title="Visual Studio Code" alt="Visual Studio Code" />
        <img src={git} title="Git" alt="Git" />
        <img src={github} title="Github" alt="Github" />
        <img src={figma} title="Figma" alt="Figma" />
        <img src={wordpress} title="wordpress" alt="wordpress" />
        <img src={postman} title="Postman" alt="Postman" />
      </section>
    </main>
  );
}

export default Technologies;
